var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90457 3.6246C5.85614 3.89 7.4772 5.27308 8.0465 7.15848L8.47162 8.5664L7.06712 8.3754C5.11555 8.11 3.49449 6.72692 2.92519 4.84152L2.50007 3.4336L3.90457 3.6246Z",
    fill: "#656462"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0954 3.6246C10.1439 3.89 8.5228 5.27308 7.9535 7.15848L7.52838 8.5664L8.93288 8.3754C10.8845 8.11 12.5055 6.72692 13.0748 4.84152L13.4999 3.4336L12.0954 3.6246Z",
    fill: "#656462"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8,
    width: 1,
    height: 7,
    fill: "#656462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlant);
export default __webpack_public_path__ + "static/media/icon_plant.10f2edd5a3fa91713fa00b0f44c58c21.svg";
export { ForwardRef as ReactComponent };